export const TIMEPOINTS_PER_DAY = 48

export const buildTimeLabels = (format = '24h', start = new Date()) => {
  const labels = []
  const base = new Date(start)
  base.setMinutes(0, 0, 0)
  for (let i = 0; i < TIMEPOINTS_PER_DAY; i++) {
    const d = new Date(base.getTime() + i * 30 * 60 * 1000)
    const h = d.getHours()
    const m = d.getMinutes().toString().padStart(2, '0')
    if (format === '12h') {
      const ampm = h >= 12 ? 'PM' : 'AM'
      const hr = h % 12 || 12
      labels.push(`${hr}:${m} ${ampm}`)
    } else {
      labels.push(`${h.toString().padStart(2, '0')}:${m}`)
    }
  }
  return labels
}

export const generateFakeSeries = ({
  points = TIMEPOINTS_PER_DAY,
  min = 0,
  max = 60,
  baseline = 15,
  volatility = 6,
  spikes = 2,
  spikeHeight = 45,
  dropChance = 0.08
} = {}) => {
  const clamp = (v) => Math.max(min, Math.min(max, v))
  const series = []
  let v = baseline
  const spikePositions = new Set()
  while (spikePositions.size < spikes) {
    spikePositions.add(Math.floor(Math.random() * points))
  }
  for (let i = 0; i < points; i++) {
    if (spikePositions.has(i)) {
      v = clamp(v + spikeHeight)
    } else {
      const dir = Math.random() < 0.5 ? -1 : 1
      const noise = (Math.random() * volatility) * dir
      v = clamp(v + noise)
      if (Math.random() < dropChance) {
        v = clamp(v - volatility * 2.5)
      }
    }
    series.push(Math.round(v * 10) / 10)
  }
  return series
}

export const buildDataset = (opts = {}) => {
  const values = generateFakeSeries(opts)
  const labels = buildTimeLabels(opts.format || '24h', opts.start)
  return values.map((y, i) => ({
    x: i,
    label: labels[i],
    y
  }))
}

/**
 * Transform backend response to format required by GraphicWidget.
 * Expects array of objects with shape: { date: string, value: string|number }
 *
 * @param {Array} apiData - Backend data
 * @param {string} format - '12h' or '24h'
 * @returns {Array} Formatted data for GraphicWidget
 */
export const adaptApiData = (apiData, format = '24h') => {
  if (!Array.isArray(apiData)) return []

  return apiData.map((item, index) => {
    let label = ''
    let ts = null
    try {
      const dateStr = item.date || item.timestamp
      const date = new Date(dateStr)
      ts = date.getTime()
      if (format === '12h') {
        label = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
      } else {
        label = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
      }
    } catch (e) {
      console.warn('Error formatting date', e)
      label = '--:--'
    }

    // Ensure value is a number, default to 0 if invalid
    let val = 0
    if (item.value !== undefined && item.value !== null) {
      val = Number(item.value)
      if (isNaN(val)) val = 0
    }

    return {
      x: index,
      y: val,
      label,
      ts
    }
  })
}
